module.exports = __webpack_public_path__ + "img/page4-4.060759ec.png";